import { render, staticRenderFns } from "./Lagerentwicklung.vue?vue&type=template&id=22eeae56&"
import script from "./Lagerentwicklung.vue?vue&type=script&lang=js&"
export * from "./Lagerentwicklung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports